import React from 'react';
import { useTranslation } from 'react-i18next';
import { isMobileOnly } from 'react-device-detect';
import PropTypes from 'prop-types';
import Button from '../common/Button';

function StartButton({ disabled, title }) {
  const { t } = useTranslation();

  return (
    <Button
      label={t('startPage.continue')}
      name="submit-button"
      type="submit"
      form="setup-form"
      cssClass={`btn ${isMobileOnly ? 'btn-block fixed-bottom' : 'min-width'}`}
      disabled={disabled}
      title={title}
    />
  );
}

StartButton.propTypes = {
  disabled: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
};

export default StartButton;
